import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ContainedButton } from './StyledButtons';
import Colors from '../../constants/Colors';
import { InfoOutlined } from '@mui/icons-material';

export const BANNER_VARIANTS = {
    INFO: 'info',
    WARNING: 'warning'
}

const StyledBanner = ({ 
    onFix,
    title,
    variant = BANNER_VARIANTS.INFO,
    description
}) => {

  const getBackgroundColor = () => {
    switch(variant) {
        case BANNER_VARIANTS.WARNING:
            return Colors.warningBackground
        case BANNER_VARIANTS.INFO:
        default:
            return "#fff";
        
    }
  }

  const getIcon = () => {
    switch(variant) {
        case BANNER_VARIANTS.WARNING:
            return <WarningAmberIcon sx={{ color: '#fff' }} />
        case BANNER_VARIANTS.INFO:
        default:
            return <InfoOutlined />
        
    }
  }

  return (
    <Paper elevation={1} sx={{ width: '100%', backgroundColor: getBackgroundColor() }} variant='outlined'>
      <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" sx={{padding: '18px'}}>
        <Box display="flex" alignItems="center" gap={2}>
          {getIcon()}
          <Box>
            <h4 style={{ fontSize: '20px', padding: 0, marginTop: 0, marginBottom: 0}}>
              {title}
            </h4>
            <p style={{ marginTop: 0, paddingTop: 0, marginBottom: 0, paddingBottom: 0}}>
              {description}
            </p>
          </Box>
        </Box>
        { onFix && <ContainedButton onClick={onFix}>Fix Now</ContainedButton> }
      </Box>
    </Paper>
  );
};

export default StyledBanner;